import React from 'react';

import { ValueBox, ValueGroup, ValueToggle } from '@candu-ai/craft/ui';
import { useManageFormFieldValidation } from '@candu-ai/forms/editor-utils';

interface Props {
  setProps: (props: Record<string, any>) => void;
  inputNamePrefix?: string;
  validation?: { type: string; message: string }[];
  label: string;
}

export const FieldRequirement = ({
  setProps,
  inputNamePrefix = 'form-input',
  validation,
}: Props) => {
  const { validationIndexMapping, isRequired } = useManageFormFieldValidation({
    setProps,
    validation,
  });

  const onToggleRequired = () => {
    if (!isRequired) {
      setProps({
        validation: [...(validation || []), { type: 'required', message: 'Required' }],
      });
    } else if (
      typeof validation !== 'undefined' &&
      validation.length > 0 &&
      typeof validationIndexMapping.required !== 'undefined'
    ) {
      const newValidation = [...validation];
      newValidation.splice(validationIndexMapping.required, 1);
      setProps({ validation: newValidation });
    }
  };

  return (
    <ValueGroup>
      <ValueBox label="Required">
        <ValueToggle
          toggleGroup={`${inputNamePrefix}-field-requirement`}
          onClick={onToggleRequired}
          isActive={isRequired}
        />
      </ValueBox>
    </ValueGroup>
  );
};
